import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import getUnicodeFlagIcon from 'country-flag-icons/unicode';


export default /*#__PURE__*/_defineComponent({
  __name: 'CountrySelectFrom',
  setup(__props) {

const options = [
  {
    key: 'Ireland',
    value: 'ie',
    label: `${getUnicodeFlagIcon('ie')} Ireland`,
  },
];

return (_ctx: any,_cache: any) => {
  const _component_a_select = _resolveComponent("a-select")!

  return (_openBlock(), _createBlock(_component_a_select, {
    ref: "countrySelect",
    "show-search": "",
    size: "large",
    class: "base-country-select",
    options: options,
    value: "ie"
  }, null, 512))
}
}

})